import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.scss';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import StatusFindep from './StatusFindep';
import Login from './views/login/Login';
import { GoogleOAuthProvider } from '@react-oauth/google';
import AuthProvider from './components/authProvider/AuthProvider';

const router = createBrowserRouter([
  {
    path: '/*',
    element: <StatusFindep />,
    // errorElement: <ErrorPage />,
  },
  {
    path: '/login',
    element: <Login />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider
    // TODO: Agregar Google Client ID de manera segura
    clientId='690992039442-7i1abco1ppl0t2b2qa40dc3c5nfe2m9e.apps.googleusercontent.com'
  >
    <React.StrictMode>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </React.StrictMode>
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
